export function contentfulAssetUrlToUrl(url: string): string | undefined {
  return (url && !url.startsWith('http') && `https:${url}`) || url
}
